export default __webpack_public_path__ + "static/how-to-expressive-974e3278ff0635b1804e9664dbdeb435.mp4";